import type { ReplyOutcome } from "@/types/reports";

import { AI_ASSISTANT } from "@/config/constants";
import { SERIES_COLOR } from "@/utils/chart-color";

/**
 * The words and colours each card uses for a slice, and the words its drilldown
 * uses for the same row.
 *
 * One table rather than one per card: a wedge labelled "Needs human" that opens
 * a list whose rows say `human_required` is the drilldown reading as a
 * different question from the number that opened it.
 */

/** A reviewer's thumb. Status colours: a verdict is a judgement, not a category. */
export const REPLY_VERDICT_LABEL: Record<string, string> = {
  up: "Rated up",
  down: "Rated down",
};

export const REPLY_VERDICT_COLOR: Record<string, string> = {
  up: "var(--success)",
  down: "var(--danger)",
};

/** What a run's non-tool steps did, for the summary line under a draft. Both
 *  the stored names and the ones the wire still sends. */
export const RUN_STEP_LABEL: Record<string, string> = {
  reply: "Drafted a reply",
  response: "Drafted a reply",
  answer: "Answered the teammate",
  stop: "Did not answer",
};

export const REPLY_OUTCOME_COLOR: Record<ReplyOutcome, string> = {
  sent: "var(--success)",
  auto_sent: SERIES_COLOR.blue,
  edited_sent: "var(--accent)",
  discarded: SERIES_COLOR.sand,
  steered: SERIES_COLOR.purple,
  superseded: SERIES_COLOR.neutral,
  taken_over: "var(--danger)",
};

/** How a gated tool call was let through, or was not. */
export const STEP_APPROVAL_LABEL: Record<string, string> = {
  auto: "Performed automatically",
  approved: "Approved by a human",
  denied: "Declined by a human",
  awaiting: "Waiting for approval",
};

/** Who actually wrote an outbound message. */
export const AUTHORSHIP_LABEL: Record<string, string> = {
  autopilot: `${AI_ASSISTANT.name} sent it on its own`,
  verbatim: `${AI_ASSISTANT.name} wrote it, a teammate approved it`,
  edited: `${AI_ASSISTANT.name} wrote it, a teammate changed it`,
  assisted: `A teammate wrote it with ${AI_ASSISTANT.name}'s help`,
  human: "A teammate wrote it themselves",
};
